import { ApiError } from '@/shared/api/client';
import type { CreditParameterApi } from '@/shared/api/resources';

/**
 * O escopo do editor: a empresa da sessao ou o padrao global da plataforma.
 *
 * O editor e um so. O que muda entre os dois e o conjunto de rotas, a chave do cache
 * e quem pode editar e ativar; quem decide de verdade continua sendo o servidor.
 */
export interface EscopoDoEditor {
  tipo: 'empresa' | 'plataforma';
  api: CreditParameterApi;
  /** Prefixo das chaves de consulta, para os dois escopos nao dividirem o cache. */
  chave: string;
  /** Pode abrir e editar rascunho. */
  podeEditar: boolean;
  /** Pode ativar versao. */
  podeAtivar: boolean;
}

/** Rota que a instalacao ainda nao tem (governanca construida em paralelo). */
export function rotaAusente(erro: unknown): boolean {
  return erro instanceof ApiError && erro.status === 404;
}

/** Codigo do servidor para quem criou ou editou a versao e tenta ativa-la. */
export const CODIGO_SEGREGACAO = 'CREDITO_SEGREGACAO_DE_FUNCOES';

export const MENSAGEM_AUTOAPROVACAO =
  'Voce criou ou editou este rascunho, e a sua conta esta liberada para ativa-lo mesmo assim. ' +
  'A ativacao fica registrada como autoaprovacao na versao e na trilha.';

export const MENSAGEM_SEGREGACAO =
  'Quem criou ou editou este rascunho nao pode ativa-lo (segregacao de funcoes). ' +
  'A ativacao precisa ser feita por outra pessoa com a permissao de aprovar.';

/**
 * Codigo do servidor para a segunda aprovacao da mesma pessoa na mesma versao. So
 * acontece quando a plataforma exige mais de um aprovador.
 */
export const CODIGO_APROVACAO_REPETIDA = 'CREDITO_APROVACAO_REPETIDA';

export const MENSAGEM_APROVACAO_REPETIDA =
  'Voce ja aprovou esta versao. A plataforma exige mais de um aprovador, e a ' +
  'proxima aprovacao precisa ser de outra pessoa com a permissao de aprovar.';

/** Mensagem do erro para a pessoa, com os casos da segregacao explicados. */
export function mensagemDoErro(erro: unknown): string {
  if (erro instanceof ApiError && erro.code === CODIGO_SEGREGACAO) {
    return MENSAGEM_SEGREGACAO;
  }
  if (erro instanceof ApiError && erro.code === CODIGO_APROVACAO_REPETIDA) {
    return MENSAGEM_APROVACAO_REPETIDA;
  }
  if (erro instanceof Error) return erro.message;
  return 'Erro inesperado.';
}
